// 判断是在ios端还是在android端
function judgeType(){
    let userAgent = navigator.userAgent;
    if((/MicroMessenger/i.test(userAgent)) && (/ipad|iphone|ipod/i.test(userAgent))){
        return "isWxIos"
    }else if((/MicroMessenger/i.test(userAgent)) && (/Android/i.test(userAgent))){
        return "isWxAndroid"
    }else if (/ipad|iphone|ipod/i.test(userAgent)) {
       return "ios"
    }else if(/Android/i.test(userAgent)){
        return "android"
    }else{
        return ""
    }
}

export default {
    judgeType
}